// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from 'wix-location';

$w.onReady(function () {
	//TODO: write your page related code here...
	
});

export function btnDownloadStreamer_click(event) {
	wixLocation.to("https://download.vrdesktop.net/files/VirtualDesktop.Streamer.Setup.exe");
}